import {useQuery} from '@tanstack/react-query';
import {Link} from 'react-router-dom';
import {Images,Megaphone,Tag} from 'lucide-react';
import {Page,Panel} from '../shell/Page';
import {usePriceMyFloor} from '../hooks/useReads';
import {authHeaders,fetchImpl} from '../lib/api';
import {env} from '../lib/env';
import {useT} from '../lib/i18n';

type Candidate={status:'not_started'|'draft'|'released'|'taken_down'};

export function Website(){
 const {t}=useT();
 const pricing=usePriceMyFloor();
 const showcase=useQuery({queryKey:['website-showcase-summary'],queryFn:async()=>{
  const r=await fetchImpl(`${env.apiBase}/api/showcase/candidates`,{headers:await authHeaders()});
  const body=await r.json() as {rows?:Candidate[];error?:string};
  if(!r.ok||!body.rows)throw Error(body.error??'Showcase unavailable');
  return body.rows;
 }});
 const released=showcase.data?.filter(x=>x.status==='released').length??0;
 const drafts=showcase.data?.filter(x=>x.status==='draft').length??0;
 return <Page kicker={t('website.kicker')} title={t('website.title')} lede={t('website.lede')}>
  <div className="grid gap-4 xl:grid-cols-3">
   <WebsiteCard icon={<Tag className="h-5 w-5"/>} title={t('website.pricingTitle')} description={t('website.pricingDescription')} metric={pricing.isPending?t('website.loading'):pricing.isError?t('website.unavailable'):t('website.pricingMetric',{listed:pricing.data?.listed??0,total:pricing.data?.products.length??0})} to="/price-my-floor" action={t('website.pricingAction')}/>
   <WebsiteCard icon={<Megaphone className="h-5 w-5"/>} title={t('website.marketingTitle')} description={t('website.marketingDescription')} metric={t('website.marketingMetric')} to="/marketing" action={t('website.marketingAction')}/>
   <WebsiteCard icon={<Images className="h-5 w-5"/>} title={t('website.showcaseTitle')} description={t('website.showcaseDescription')} metric={showcase.isPending?t('website.loading'):showcase.isError?t('website.unavailable'):t('website.showcaseMetric',{released,drafts,total:showcase.data?.length??0})} to="/showcase" action={t('website.showcaseAction')}/>
  </div>
  <Panel className="mt-4" title={t('website.operatingTitle')}><p className="max-w-4xl text-sm text-muted-foreground">{t('website.operatingNote')}</p></Panel>
 </Page>;
}

function WebsiteCard({icon,title,description,metric,to,action}:{icon:React.ReactNode;title:string;description:string;metric:string;to:string;action:string}){
 return <Panel title={<span className="flex items-center gap-2">{icon}{title}</span>} className="flex flex-col">
  <p className="min-h-16 text-sm text-muted-foreground">{description}</p>
  <p className="my-4 border-y py-3 text-sm font-medium">{metric}</p>
  <Link className="mt-auto inline-flex min-h-10 items-center justify-center rounded-md bg-primary px-4 text-sm font-medium text-primary-foreground" to={to}>{action} →</Link>
 </Panel>;
}
